export default {
    required: "Je vyžadována hodnota",
    email: "Hodnota není platná e-mailová adresa.",
    mask: "Hodnota je neplatná.",
    maxValue: "Maximální hodnota je {max}",
    maxLength: "Maximální povolená délka je {max}",
    regex: "Hodnota je neplatná.",
    server: {
        DELEGATES_NOT_ENABLED: "Delegáti pro tohoto partnera nejsou povoleni.",
        DELEGATE_DOES_NOT_EXIST: "Delegát neexistuje",
        DELEGATE_UPDATE_PERMISSIONS_MISMATCH: "Nelze aktualizovat delegáta, který vám nepatří.",
        DELEGATE_DELETE_PERMISSIONS_MISMATCH: "Nelze smazat delegáta, který vám nepatří.",
        DELEGATE_ALREADY_EXISTS: "Existující pravidlo delegáta, které odpovídá tomuto kritériu, již existuje.",
        DELEGATE_CANNOT_BE_SELF: "Nemůžete se přidat jako delegáta.",
        IMPERSONATE_USER_NO_PERMISSIONS: "Uživatel {email} nemá přístup k DXC Gear a nelze za něj provádět objednávky.",
        INVALID_CART_ITEM: "Produkt {product} není povolen",
        INVALID_USER_TYPE: "Typ uživatele není zaměstnanec",
        INVALID_EMPLOYMENT_STATUS: "Uživatel není aktivním zaměstnancem",
        USER_NOT_FOUND: "Uživatel nebyl nalezen",
        "Invalid user type": "Neplatný typ uživatele",
        "User not found": "Uživatel nebyl nalezen"
    }
}